import React from 'react';
import Down from 'assets/svg/Down';
import DownSelected from 'assets/svg/DownSelected';
import { useNavigate } from 'react-router-dom';
import { Popover } from 'antd';
import { config } from 'process';
import { trackEventMixpanel } from 'utils/mixpanel';
import { GLOBAL_NAV_HOVER, GLOBAL_NAV_NAVIGATION } from 'utils/mixpanelEventNames';

interface Props {
    navOptions: any;
    mouseOverListVisible: Function;
    pathInfo: any;
}

function NavBarOptions({ navOptions, mouseOverListVisible, pathInfo }: Props) {
    const navigate = useNavigate();

    const content = (item: any) => {
        return (
            <div
                className="bg-white min-h-[8rem] min-w-[10rem] gap-9 flex justify-start rounded-b-lg font-medium font-xs"
                //style={{ top: '6vh' }}
            >
                {item.options?.Promo?.length > 0 && (
                    <div>
                        <ul>
                            {item?.showSubHeader && <li className="text-purpleFont mb-4">Promo</li>}
                            {item.options.Promo?.map((list: any) => {
                                return (
                                    <li
                                        className={`mb-2 cursor-pointer ${
                                            pathInfo?.[0] === list?.path ? 'font-bold' : 'font-normal'
                                        }`}
                                        onClick={() => {
                                            navigate(`/${item.path?.[0]}/${list.path}`);

                                            //mixpanel event
                                            trackEventMixpanel(GLOBAL_NAV_NAVIGATION, {
                                                screen: list?.label,
                                                screenHeader: item?.label,
                                                url: `/${item.path?.[0]}/${list.path}`,
                                            });
                                        }}
                                        key={list.label}
                                    >
                                        {list.label}
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                )}

                {item.options?.Pricing?.length > 0 && (
                    <div>
                        <ul>
                            {item.options.Pricing && item?.showSubHeader && (
                                <li className="text-purpleFont mb-4">Pricing</li>
                            )}
                            {item.options.Pricing?.map((list: any) => {
                                return (
                                    <li
                                        className={`mb-2 cursor-pointer ${
                                            pathInfo?.[0] === list?.path ? 'font-bold' : 'font-normal'
                                        }`}
                                        onClick={() => {
                                            navigate(`/${item.path?.[1]}/${list.path}`);

                                            //mixpanel event
                                            trackEventMixpanel(GLOBAL_NAV_NAVIGATION, {
                                                screen: list?.label,
                                                url: `/${item.path?.[1]}/${list.path}`,
                                            });
                                        }}
                                        key={list.label}
                                    >
                                        {list.label}
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                )}
            </div>
        );
    };
    return (
        <span className="flex items-center ml-6 rounded gap-x-1">
            {navOptions?.map((item: any, key: number) => {
                const isSelected = pathInfo?.input.includes(item.path?.[0]) || pathInfo?.input.includes(item.path?.[1]);
                return (
                    <Popover
                        onOpenChange={(visible) => {
                            if (visible) trackEventMixpanel(GLOBAL_NAV_HOVER, { from: item?.label });
                        }}
                        overlayInnerStyle={{ position: 'relative', top: -5 }}
                        content={() => content(item)}
                        placement="bottomLeft"
                        showArrow={false}
                        trigger={'hover'}
                        key={key}
                    >
                        <div
                            className="relative"
                            // onClick={() => mouseOverListVisible(navOptions, item.label)}
                            key={item.path}
                        >
                            <div
                                className={`flex justify-center items-center rounded gap-x-2 p-2 cursor-pointer text-purpleFont ${
                                    isSelected ? 'font-bold bg-bgBackground' : ''
                                } `}
                            >
                                <span>{item.label}</span>
                                <span>{isSelected ? <DownSelected /> : <Down />}</span>
                            </div>
                        </div>
                    </Popover>
                );
            })}
        </span>
    );
}

export default NavBarOptions;
